/** Subtitle under auth card titles (login / sign-up entry / email sign-up). */
export const AUTH_LOGIN_CARD_DESCRIPTION = "Sign in to your account";
export const AUTH_SIGNUP_CARD_DESCRIPTION = "Create your new account";

/** Auth card layout — keep in sync with mobile [AuthCardCopy]. */
export const AUTH_CARD_TITLE_TO_DESCRIPTION_GAP_PX = 14;
export const AUTH_CARD_DESCRIPTION_TO_CONTENT_GAP_PX = 20;

/** Space above card title (mobile: CardHeader + CardTitle padding). */
export const AUTH_CARD_HEADER_TOP_LOGIN_PX = 56;
export const AUTH_CARD_HEADER_TOP_SIGNUP_ENTRY_PX = 40;
export const AUTH_CARD_HEADER_TOP_SIGNUP_EMAIL_PX = 56;
